import { render } from "./OrderTheList.vue?vue&type=template&id=460d8b0f&scoped=true"
import script from "./OrderTheList.vue?vue&type=script&lang=js"
export * from "./OrderTheList.vue?vue&type=script&lang=js"

import "./OrderTheList.vue?vue&type=style&index=0&id=460d8b0f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460d8b0f"]])

export default __exports__